module.exports = __webpack_public_path__ + "img/transparent-hack.c8fc8aa9.png";